import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationsGetRequest = simpleAction(TYPES.ITEM_SPECIFICATIONS_GET_REQUEST);

/**
 * Request itemSpecifications success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationsGetSuccess = simpleAction(TYPES.ITEM_SPECIFICATIONS_GET_SUCCESS);

/**
 * Request itemSpecifications error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationsGetError = simpleAction(TYPES.ITEM_SPECIFICATIONS_GET_FAIL);

/**
 * Request Product
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationLoadRequest = simpleAction(TYPES.ITEM_SPECIFICATION_LOAD_REQUEST);

/**
 * Request Product success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationLoadSuccess = simpleAction(TYPES.ITEM_SPECIFICATION_LOAD_SUCCESS);

/**
 * Request Product error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationLoadError = simpleAction(TYPES.ITEM_SPECIFICATION_LOAD_FAIL);

/**
 * Create Product
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationCreateRequest = simpleAction(TYPES.ITEM_SPECIFICATION_CREATE_REQUEST);

/**
 * Create Product Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationCreateSuccess = simpleAction(TYPES.ITEM_SPECIFICATION_CREATE_SUCCESS);

/**
 * Create Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationCreateError = simpleAction(TYPES.ITEM_SPECIFICATION_CREATE_FAIL);

/**
 * Create Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationCreateDone = simpleAction(TYPES.ITEM_SPECIFICATION_CREATE_DONE);

/**
 * Update Product
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationUpdateRequest = simpleAction(TYPES.ITEM_SPECIFICATION_UPDATE_REQUEST);

/**
 * Update Product Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationUpdateSuccess = simpleAction(TYPES.ITEM_SPECIFICATION_UPDATE_SUCCESS);

/**
 * Update Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationUpdateError = simpleAction(TYPES.ITEM_SPECIFICATION_UPDATE_FAIL);

/**
 * Update Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemSpecificationUpdateDone = simpleAction(TYPES.ITEM_SPECIFICATION_UPDATE_DONE);

export const itemSpecificationIsCreatedOrUpdated = simpleAction(TYPES.ITEM_SPECIFICATION_IS_CREATED_OR_UPDATED);
export const itemSpecificationIsCreatedOrUpdatedReset = simpleAction(
    TYPES.ITEM_SPECIFICATION_IS_CREATED_OR_UPDATED_RESET
);
